export default __webpack_public_path__ + "images/newIframe/customers@2x.png";